import { useEffect } from "react";
type ExternalRedirectProps = {
  to: string;
};


function ExternalRedirect({ to }: ExternalRedirectProps) : JSX.Element | null {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default ExternalRedirect;